var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"height":"100%"}},[_c('Toolbar',{attrs:{"toolbarTitle":_vm.$t('Gruppenforen Gruppen')}}),_c('GroupMemberList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }